import script from "./WalletWatchlistMemberDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletWatchlistMemberDisplay.vue?vue&type=script&setup=true&lang=js"

import "./WalletWatchlistMemberDisplay.vue?vue&type=style&index=0&id=2404096f&lang=css"

const __exports__ = script;

export default __exports__